import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import IconButton from 'material-ui/IconButton';
import MenuIcon from 'material-ui-icons/Menu';
import { connect } from 'react-redux';
import { setDrawerOpened } from '../FormStepper/Drawer/drawerActions';

const styles = theme => ({
    root: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    navIconHide: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
});

function HamburgerButton(props) {
    return (
        <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => {
                props.setDrawerOpened(true);
            }}
            className={props.classes.navIconHide}
        >
            <MenuIcon />
        </IconButton>
    );
}

const mapDispatchToProps = dispatch => ({
    setDrawerOpened: (drawerOpened) => {
        dispatch(setDrawerOpened(drawerOpened));
    },
});

HamburgerButton.propTypes = {
    classes: PropTypes.object.isRequired,
    setDrawerOpened: PropTypes.func.isRequired,
};

export default connect(
    null,
    mapDispatchToProps,
)(withStyles(styles)(HamburgerButton));



// WEBPACK FOOTER //
// ./src/app/layout/HamburgerButton.js